import validation from '../../../../../../modules/Gull/Framework/validation.js';

const stap2 = {
	init() {
		// Run immediately
		this.displayContactBlock('financieel');
		this.displayContactBlock('arbo');

		// Also run on DOMContentLoaded in case the DOM isn't ready yet
		document.addEventListener('DOMContentLoaded', () => {
			this.displayContactBlock('financieel');
			this.displayContactBlock('arbo');
		});

		// Toon de financiele contactpersoon
		document.getElementById('activate_contact_financieel').addEventListener('change', () => {
			this.displayContactBlock('financieel');
		});

		// Toon de contactpersoon van arbo
		document.getElementById('activate_contact_arbo').addEventListener('change', () => {
			this.displayContactBlock('arbo');
		});
	},

	displayContactBlock(role) {
		const checkbox = document.getElementById(`activate_contact_${role}`);
		const contactBlock = document.querySelector(`.contact-block-${role}`);

		if (checkbox.checked) {
			contactBlock.classList.remove('d-none');
			contactBlock.querySelectorAll('input:not(.tussenvoegsel):not(.iti__search-input), select:not(.tussenvoegsel)').forEach(element => {
				validation.addRequired(element);
			});
		} else {
			contactBlock.classList.add('d-none');
			contactBlock.querySelectorAll('input:not(.tussenvoegsel), select:not(.tussenvoegsel)').forEach(element => {
				validation.removeRequired(element);
			});
		}
	}
};

export default stap2;
